const initialState = {
  selectedVoucher: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_VOUCHER":
      return {
        ...state,
        selectedVoucher: payload
      }

    case "CLEAR_VOUCHER":
      return {
        ...state,
        selectedVoucher: null
      }

    default:
      return state
  }
}
